module.exports = __webpack_public_path__ + "media/images/groupRank__eval--correct@3x-cc149460396859aae3b82f82cafd8b00.png";